import React from 'react';
import './CompetitionModePill.css';

type CompetitionMode = 'individual' | 'team' | 'unknown';

function normalizeMode(input?: string | null): CompetitionMode {
  const raw = (input || '').trim().toLowerCase();
  if (raw === 'individual' || raw === 'team') {
    return raw;
  }
  return 'unknown';
}

function labelForMode(mode: CompetitionMode): string {
  switch (mode) {
    case 'team':
      return 'Team';
    case 'individual':
      return 'Individual';
    default:
      return 'Unknown';
  }
}

export interface CompetitionModePillProps {
  mode?: string | null;
  className?: string;
}

const CompetitionModePill: React.FC<CompetitionModePillProps> = ({ mode, className = '' }) => {
  const normalized = normalizeMode(mode);
  const label = labelForMode(normalized);

  return (
    <span
      className={`competition-mode-pill competition-mode-pill--${normalized} ${className}`.trim()}
      title={`Competition mode: ${label}`}
      aria-label={`Competition mode: ${label}`}
    >
      {label}
    </span>
  );
};

export default CompetitionModePill;
